<template>
    <ProductListDialog :dialogTitle="dialogTitle" :centerDialogVisible="visible" @updateVisible="updateVisible"
                       @resetPopupData="resetPopupData" @submitPopupData="submitPopupData" :popupWidth="'1000px'"
                       :show-btn="false" :show-close-btn="true"

    >
<!--        <el-form :inline="true" :model="query" ref="query">-->
           <div style="margin-bottom: 10px">
               <e-search
                       :data="query"
                       :field-list="fieldList"
                       :list-type-info="listTypeInfo"
                       :width="listTypeInfo.width"
                       @handleFilter="handleSearch"
                       @handleReset="handleClear"
                       @handleFocus="focusClassify"
                       @handleExport="exportFile"
                       :btn-style="btnStyle"
               ></e-search>
           </div>

<!--            <el-form-item label="商品编号" prop="skuCode">-->
<!--                <el-input v-model="query.skuCode" placeholder="商品编号"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="商品名称" prop="skuName">-->
<!--                <el-input v-model="query.skuName" placeholder="商品名称"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="类目名称" prop="categoryName">-->
<!--                <el-input v-model="query.categoryName" placeholder="商品名称"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="品牌" prop="brandName">-->
<!--                <el-input v-model="query.brandName" placeholder="商品名称"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>-->
<!--            <el-button type="primary" icon="el-icon-delete" @click="handleClear">重置</el-button>-->
<!--            <el-button type="primary" @click="exportFile">导出</el-button>-->
<!--        </el-form>-->
        <TableList :table-data="tableData" :table-label="tableLabel" :loading="loading"
                   :selection-show="multipleSelection">
            <template v-slot:pic="slot">
                <img :src="slot.scope.row.defaultImage" style="width: 48px;height: 48px" />
            </template>
            <template v-slot:rate="slot">
                {{slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-'}}
            </template>
        </TableList>

        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]" layout="total, sizes, prev, pager, next, jumper"
                           :current-page="productTagPage.currentPage" :page-size="productTagPage.pageSize"
                           :total="productTagPage.pageTotal" prev-text="上一页" next-text="下一页">
            </el-pagination>
        </div>

        <!-- 所属分类 -->
        <classifyTree
                :classifyVisible="classifyVisible"
                :categoryTreeData="categoryTreeData"
                :defaultCheckedKeys="defaultCheckedKeys"
                @submitPopupData="classifySubmitPopupData"
                @resetPopupData="classifyResetPopupData"
        ></classifyTree>
    </ProductListDialog>
</template>

<script>
    import ProductListDialog from "../../../../../components/common/epecDialog";
    import TableList from "../../common/e-table-list";
    import agreementApi from "../../../api/agreement/index";
    import utils from "../../../utils/utils";
    import ESearch from '../../common/e-search'
    import ClassifyTree from './classifyTree'
    export default {
        name: "sharedResourceProductDialog",
        components: {
            ProductListDialog,
            TableList,
            ESearch,
            ClassifyTree
        },
        props: {
            visible: {
                type: Boolean,
                required: true,
            },
            userIdentity: {
                type: Number,
                default: 0,
            },
            agreementId: {
                type: Number,
                required: true,
                default: 0,
            },
            supplierCompanyId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                loading: false,
                tableData: [],
                tableLabel: [

                    {
                        label: "商品编号",
                        param: "skuCode",
                        align: "center"
                    },
                    {
                        label: "商品名称",
                        param: "skuName",
                        align: "center"
                    },
                    {
                        label: "类目名称",
                        param: "categoryName",
                        align: "center"
                    },
                    {
                        label: "计量单位",
                        param: "unitValue",
                        align: "center"
                    },
                    {
                        label: "品牌",
                        param: "brandName",
                        align: "center"
                    },
                    {
                        label: "平台价(元)",
                        param: "skuPrice",
                        align: "center"
                    },
                    {
                        label: "协议价(元)",
                        param: "agreementTempPrice",
                        align: "center"
                    },

                    {
                        label: "商品状态",
                        param: "companyShowStatus",
                        align: "center",
                    },
                ],
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                query:{
                    skuCode:'',
                    skuName:'',
                    categoryName:'',
                    brandName:'',
                    categoryIdList:null
                },
                dialogTitle: "商品清单",
                multipleSelection: false,
                fieldList: [
                    { label: '商品编码', type: 'input', value: 'skuCode', placeholder: '支持模糊搜索' },
                    { label: '商品名称', type: 'input', value: 'skuName', placeholder: '支持模糊搜索' },
                    { label: '类目名称', type: 'dialog', value: 'categoryName', placeholder: '支持多选' },
                    { label: '品牌名称', type: 'input', value: 'brandName', placeholder: '支持模糊搜索' },
                ],
                listTypeInfo: {
                    width: {
                        labelWidth: 120,
                        itemWidth: 200
                    },
                },
                btnStyle:[
                    { icon: null, text: "重置" },
                    { icon: null, text: "查询", type: "primary" },

                    { icon: null, text: "导出", type: "primary" },
                ],
                // 所属分类
                classifyVisible: false,
                classifyData: null,
                defaultCheckedKeys: [],
                categoryTreeData:[],
            };
        },
        computed: {},
        created() {
            this.getProductPriceList();
        },
        methods: {
            async exportFile() {
                let params = this.formatParams()
                agreementApi.sharedAgreementExportProductList(params).then(res => {
                    if (res.type == "application/json") {
                        utils.fileExportResponseError(res);
                    } else {
                        utils.downFile(res);
                    }
                });
            },
            handleSearch(val) {
                this.query = {...val}
                this.getProductPriceList();
            },
            handleClear() {
                this.query.skuName = "";
                this.query.skuCode = "";
                this.query.categoryName = ''
                this.query.brandName = ''
                this.query.categoryIdList=null
                this.getProductPriceList()
            },
            handleSizeChange(val) {
                this.productTagPage.pageSize = val;
                this.productTagPage.currentPage = 1
                this.getProductPriceList();
            },
            handleCurrentChange(val) {
                this.productTagPage.currentPage = val;
                this.getProductPriceList();
            },
            updateVisible() {},
            resetPopupData() {
                this.$emit("close");
            },
            submitPopupData() {
                this.$emit('close')
            },
            getProductPriceList() {
                let params = this.formatParams();
                agreementApi.getSharedResourceProductList(params).then((res) => {
                    if (res.data) {
                        this.tableData = res.data.records;
                        this.productTagPage.pageTotal = res.data.total;
                    }
                });
            },
            formatParams() {
                let res = {};
                res.pageNum = this.productTagPage.currentPage;
                res.pageSize = this.productTagPage.pageSize;
                res.agreementId = this.agreementId;
                res.skuName = this.query.skuName;
                res.skuCode = this.query.skuCode;
                res.categoryIdList = this.query.categoryIdList
                res.brandName = this.query.brandName
                res.supplierCompanyId = this.supplierCompanyId
                return res;
            },
            formatConfirmStatus(val) {
                let res = "";
                switch (val) {
                    case 0:
                        res = "未提交";
                        break;
                    case 1:
                        res = "待确认";
                        break;
                    case 2:
                        res = "已确认";
                        break;
                    case 3:
                        res = "拒绝";
                        break;
                    case 4:
                        res = '已停用';
                        break;
                }
                return res;
            },
            formatRate(val) {
                return ((((val.price - val.agreementPrice) / val.price) * 100).toFixed(2)) + '%'
            },
            // 选择所属分类
            focusClassify() {
                this.getAllCategoryTree()
                if (this.query.categoryIdList?.length) {
                    this.defaultCheckedKeys = this.query.categoryIdList
                }
                this.classifyVisible = true
            },
            async getAllCategoryTree() {
                let params = {
                    agreementId:this.agreementId
                }
                let res = await agreementApi.getSharedResourceAllCategoryTree(params)
                if (res.code == '200') {
                    this.categoryTreeData = res.data.children
                }
            },
            // 关闭所属分类弹框
            classifyResetPopupData() {
                this.classifyVisible = false
            },

            // 所属分类确定
            classifySubmitPopupData(val) {
                // this.defaultCheckedKeys = val.map(item=>item.categoryId)
                let filterNode = []
                val.map((item) => {
                    if (item.leafFlag) {
                        filterNode.push(item)
                    }
                })
                console.log(filterNode, '过滤后的categoryId')
                this.query.categoryIdList = filterNode.map((item) => item.categoryId)
                let arr = val.map((item) => item.categoryName)
                this.query.categoryName = arr.join('、')
                this.classifyVisible = false
            },
        },
    };
</script>

<style lang="scss" scoped>
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }

    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
</style>
